import type { Asset } from "@hydrologiq/gql-experience/graphql"

const NOT_FUEL = ["water", "waste", "power"]

/**
 * Whether a Module is one a hybrid parent's fuel level is worked out from: class fuel, or Fuel Storage (class
 * storage with category diesel or hydrogen). A water or waste tank never counts. Mirrors the Modules core's
 * `_compute_fuel_level` reads (core/logiq/api/experience/experience/domain/hybrid_figures_service.py).
 */
export function isFuelModule(module: Pick<Asset, "class" | "category">): boolean {
  const assetClass = module.class?.toLowerCase()
  const category = module.category?.toLowerCase()
  if (assetClass === "fuel") return !category || !NOT_FUEL.includes(category)
  return assetClass === "storage" && (category === "diesel" || category === "hydrogen")
}

/**
 * Whether a parent Asset has any fuel Module. `undefined` when its children weren't loaded, so a caller can
 * leave things as they are rather than treat "unknown" as "none".
 */
export function hasFuelModule(asset?: Pick<Asset, "children">): boolean | undefined {
  if (!asset?.children) return undefined
  return asset.children.some(isFuelModule)
}
